"use client";

import { Button } from "@/03-presenters/components/ui/button";
import { Input } from "@/03-presenters/components/ui/input";
import { Label } from "@/03-presenters/components/ui/typography";
import { LoadingOverlay } from "@mantine/core";
import { useRequest } from "ahooks";
import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";
import { toast } from "sonner";
export default function UpdateShareCode({
  shareCode,
  isNeverPaid
}: {
  shareCode: string | null | undefined;
  isNeverPaid: boolean;
}) {
  const router = useRouter();
  const [isPending, startTransiiton] = useTransition();
  const [isValid, setIsValid] = useState(true);
  function refresh() {
    startTransiiton(() => {
      router.refresh();
    });
  }
  const [isEdit, setIsEdit] = useState(false);
  const [inputShareCode, setInputShareCode] = useState(shareCode);
  const {
    runAsync,
    loading
  } = useRequest(async () => {
    if (!inputShareCode) {
      return;
    }
    const res = await fetch(`/api/user/shareCode`, {
      method: "POST",
      body: JSON.stringify({
        shareCode: inputShareCode
      })
    });
    const json = await res.json();
    if (json.base_resp?.code === 0) {
      refresh();
      setIsEdit(false);
    } else {
      toast.error("邀请码无效，保存失败", {
        position: "top-center",
        richColors: true
      });
    }
  }, {
    manual: true
  });
  return <div className="flex items-start gap-2" data-sentry-component="UpdateShareCode" data-sentry-source-file="UpdateShareCode.tsx">
      <Label className="flex h-6 items-center text-nowrap" data-sentry-element="Label" data-sentry-source-file="UpdateShareCode.tsx">邀请码: </Label>
      {isEdit ? <div>
          <Input defaultValue={shareCode ?? ""} className="h-6" onChange={e => {
        const valueTrim = e.target.value.trim();
        setInputShareCode(valueTrim);
        setIsValid(valueTrim.length !== 0);
      }} />
          {!isValid && <div className="mt-1 text-xs text-red-600">邀请码不能为空</div>}
        </div> : <div className="relative">
          <LoadingOverlay visible={isPending} zIndex={11} overlayProps={{
        radius: "xs",
        blur: 2
      }} loaderProps={{
        size: 10
      }} />
          <Label className="flex h-6 items-center">{shareCode ?? "-"}</Label>
        </div>}
      {isNeverPaid ? isEdit ? <div className="flex items-center gap-1">
            <Button variant="link" disabled={loading} className="h-5 px-1 text-primary hover:no-underline" onClick={runAsync}>
              保存
            </Button>
            <Button variant="link" className="h-6 px-1 text-primary hover:no-underline" onClick={() => setIsEdit(false)}>
              取消
            </Button>
          </div> : <Button variant="link" className="h-6 text-primary hover:no-underline" onClick={() => setIsEdit(true)}>
            修改
          </Button> : null}
    </div>;
}